module.exports = __webpack_public_path__ + "img/special-you-icon3.047a59b7.png";